import React, { useState, useEffect } from "react";
import { Card, CardContent,Box,Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

function MackenzieWeather() {
    const [loading,setLoading]=useState(false);
    const [data,setData]=useState([]);
    const [time, setTime] = useState(Date.now());
    const useStyles = makeStyles((theme)=>({
        title: {
            color: '#e7008b',
            fontWeight:"600",
            fontSize:'3rem',
          },
          main:{
              color:'#1bc539',
              fontWeight:"600",
              fontSize:'1.5rem',
              
            },
            mainHeading:{
                color:'#1bc539',
                fontWeight:"600",
                fontSize:'2.5rem',
                margin:'5px',
            },
            max:{
                height:"95vh",
                textAlign:"center",
                fontSize:'1.2rem',
            },
    })

    );
    const classes = useStyles();

    useEffect(()=>{
        getData();
        const interval = setInterval(() => setTime(Date.now()), 10000);
            return () => {
                clearInterval(interval);
            };
    },[])

    useEffect(()=>{
        if(!loading){
            getData();
        }
    },[time])

    const getData=()=>{
        const url="https://weather.nicosiasailingclub.com/api/weather/parsemackenzie";
        setLoading(true);
        fetch(url)
        .then(res => res.text())
        .then(res => {
            const response=JSON.parse(res);
            setData(response);
            setLoading(false);
        } )
        .catch((error)=>{
            console.log("error with API call");
            console.log(error);
            setLoading(false);
        });
    }
    return (
    <>
    <div id="content">
        <Box>
            <Container>
                <br/>
                    <Card variant="outlined" className={classes.max}>
                        <CardContent>
                            <Box component="span" className={classes.title}>
                            Mackenzie
                            </Box>
                            {data.windSpeed&&<>
                                <Box component="div" className={classes.mainHeading}>
                                    {data.windSpeed} knots {data.windDir}
                                </Box>
                                    <br/>
                                    Average past hour: <Box component="span" className={classes.main}>{data.windSpeedAvg} kt</Box>
                                    <br/><br/>
                                    Updated: <Box component="span" className={classes.main}>{data.updated}</Box>
                                </>}
                        </CardContent>
                    </Card>
            </Container>
        </Box>
    </div>
    </>
);
}
export default MackenzieWeather;